<template>
  <div class="dhRechargeManage">
    <div class="balance_box" v-loading="balanceLoading">
      <img
        class="balance_icon"
        src="../../../assets/images/balance_icon.png"
        alt=""
      />
      <div class="flex1">
        <div class="flex flex_jb">
          <div class="balance_title">当换余额查询</div>
          <div class="flex">
            <span class="balance_time">最近查询时间 {{queryTime}}</span>
            <div class="search_btn" @click="searchBalance">查询</div>
          </div>
        </div>
        <div class="balance_num flex">
          <span class="mr-100"
            >当前可用余额：<span style="color: #FF9324;">{{
              availableAmount
            }}</span>
            元</span
          >
          <span
            >当前冻结余额：<span style="color: #FF5353;">{{
              frozenAmount
            }}</span>
            元</span
          >
        </div>
      </div>
    </div>
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <div class="el-form-group_isRound">
          <el-form
            ref="formData"
            :model="formData"
            inline
            size="small"
            label-width="80px"
          >
            <el-form-item label="单据号">
              <el-input
                v-model="formData.uniqNo"
                placeholder="请输入单据号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="操作人">
              <el-select
                v-model="formData.createAdminAccount"
                filterable
                clearable
                placeholder="请输入人员姓名查询"
              >
                <el-option
                  v-for="item in staffList"
                  :key="item.userAccount"
                  :label="item.userName"
                  :value="item.userAccount"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="createTime"
                :picker-options="createDatePickerOptions()"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="~"
                end-placeholder="结束日期"
                clearable
                :default-time="['00:00:00', '23:59:59']"
              />
            </el-form-item>
            <template v-if="state == '01'">
              <el-form-item label="充值时间">
                <el-date-picker
                  v-model="rechargeTime"
                  :picker-options="createDatePickerOptions()"
                  type="daterange"
                  start-placeholder="开始日期"
                  range-separator="~"
                  end-placeholder="结束日期"
                  clearable
                  :default-time="['00:00:00', '23:59:59']"
                />
              </el-form-item>
              <el-form-item label="完成时间">
                <el-date-picker
                  v-model="finishTime"
                  :picker-options="createDatePickerOptions()"
                  type="daterange"
                  start-placeholder="开始日期"
                  range-separator="~"
                  end-placeholder="结束日期"
                  clearable
                  :default-time="['00:00:00', '23:59:59']"
                />
              </el-form-item>
            </template>
            <template v-if="state == '10'">
              <el-form-item label="作废时间">
                <el-date-picker
                  v-model="cancelTime"
                  :picker-options="createDatePickerOptions()"
                  type="daterange"
                  start-placeholder="开始日期"
                  range-separator="~"
                  end-placeholder="结束日期"
                  clearable
                  :default-time="['00:00:00', '23:59:59']"
                />
              </el-form-item>
            </template>
            <el-form-item>
              <el-button
                type="primary"
                round
                :loading="searchLoading"
                @click="getTableData(1)"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="flex flex_jb">
        <GardenSlwct
          style="margin-bottom: 20px;"
          :tab-data="tabData"
          :activeIndex="tabActiveIndex"
          width="120px"
          border-radius="40px"
          @tabAction="tabAction"
        />
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="openRechargeDia"
            >创建充值</el-button
          >
          <el-button
            size="small"
            type="success"
            icon="el-icon-download"
            :loading="exportLoading"
            @click="clickExcel"
            >导出Excel</el-button
          >
        </div>
      </div>

      <GlobalTable
        ref="dhTable"
        :key="`dhTable-${state}`"
        v-loading="searchLoading"
        :columns="tableColumns"
        :data="tableDataList"
        :currentPage="page.pageNum"
        :total="page.total"
        @handleCurrentChange="getTableData"
      >
        <el-table-column label="充值金额" slot="rechargeAmount" align="center">
          <template slot-scope="{ row }">
            <span
              >{{ row.rechargeAmount }} 元</span
            >
          </template>
        </el-table-column>
        <el-table-column label="创建人" slot="optName" align="center">
          <template slot-scope="{ row }">
            <span
              >{{ row.createAdminName }} - {{ row.createAdminAccount }}</span
            >
          </template>
        </el-table-column>
        <template v-if="state == '00'">
          <el-table-column label="充值链接" slot="rechargeLink" align="center">
            <template slot-scope="{ row }">
              <span class="btn" @click="seeLink(row)">查看链接</span>
            </template>
          </el-table-column>
        </template>

        <template v-if="state == '01'">
          <el-table-column label="充值时间" slot="rechargeTime" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.rechargeTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="充值凭证"
            slot="finishVoucherList"
            align="center"
          >
            <template slot-scope="{ row }">
              <span class="btn" @click="seeVoucher(row.finishVoucherList)"
                >查看</span
              >
            </template>
          </el-table-column>
          <el-table-column label="完成操作人" slot="finishAdminName" align="center">
            <template slot-scope="{ row }">
              <span
                >{{ row.finishAdminName }} - {{ row.finishAdminAccount }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="完成时间" slot="finishTime" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.finishTime }}</span>
            </template>
          </el-table-column>
        </template>
        <template v-if="state == '10'">
          <el-table-column label="作废操作人" slot="abolishAdminName" align="center">
            <template slot-scope="{ row }">
              <span
                >{{ row.finishAdminName }} - {{ row.finishAdminAccount }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="充值作废时间"
            slot="abolishTime"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.abolishTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="作废原因" slot="abolishNote" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.abolishNote"
                placement="top"
              >
                <div class="nowrap-ellipsis">
                  {{ row.abolishNote }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          label="操作"
          slot="operation"
          align="center"
          width="240px"
          v-if="state == '00'"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="finishClick(row)"
              >完成充值</el-button
            >
            <el-button type="danger" size="small" @click="cancelClick(row)"
              >作废单据</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog
      :close-on-click-modal="false"
      width="800px"
      title="查看凭证照片"
      :visible.sync="imgDiaShow"
      top="3%"
    >
      <div class="img-box">
        <div class="imgs-num" v-if="imgList.length > 0">
          {{ imgShowIndex + 1 }}/{{ imgList.length }}
        </div>
        <div class="block">
          <viewer :images="imgList">
            <el-carousel trigger="click" height="80vh" @change="getImgIndex">
              <el-carousel-item v-for="(item, ibdex) in imgList" :key="ibdex">
                <div class="sec_img">
                  <img :src="item" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </viewer>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="创建充值"
      :visible.sync="rechargeDiaShow"
      :close-on-click-modal="false"
      width="600px"
      top="3%"
    >
      <div style="padding: 0 0 40px;">
        <div class="flex">
          <span style="flex-shrink: 0;">充值金额：</span>
          <el-input
            size="small"
            placeholder="请输入充值金额"
            maxlength="7"
            v-model.number="amount"
            @input="amountInput"
            clearable
          >
          </el-input>
          <el-button
            type="primary"
            style="margin-left: 10px;"
            size="small"
            :disabled="!rechargeAmountChinese"
            :loading="getLinkLoading"
            @click="getRechargeLink"
            >获取充值链接</el-button
          >
        </div>
        <p class="chinese_amount">{{ rechargeAmountChinese }}</p>
        <template v-if="uniqNo">
          <p class="mt-20">已生成单据号：{{ uniqNo }}</p>
          <div class="link_box">
            <p style="font-size: 16px;color: #333333;">
              请使用支付宝点击以下链接转账：
            </p>
            <p style="color: #FF5353;">
              注意：请在转账时仔细核对金额以及付款账户
            </p>
            <div class="mt-20">
              <el-button
                type="primary"
                size="mini"
                style="padding: 5px;margin-right: 10px;"
                @click="copy"
                >点击复制</el-button
              >
              <span
                style="line-height: 20px;text-decoration: underline;color: #0981ff;"
                >当换充值{{ onAmount }}元：{{ rechargeLink }}</span
              >
            </div>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer" v-if="uniqNo">
        <el-button @click.native="rechargeDiaShow = false">稍后充值</el-button>
        <el-button type="primary" @click.native="openFinishDia"
          >完成充值</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="完成充值提示"
      :visible.sync="finishClickDiaShow"
      :close-on-click-modal="false"
      width="500px"
      top="3%"
    >
      <div>
        <p style="color: #333333;">
          是否确认已完成向当换平台的繁星资金账户充值？
        </p>
        <p class=" mt-10">
          充值金额：<span style="color: #0981ff;"
            >{{ onAmount }}（{{
              rechargeAmountChinese
            }}）</span
          >
        </p>
        <div class="flex mt-10">
          <span style="flex-shrink: 0;margin-right: 15px;">充值时间:</span>
          <el-date-picker
            size="small"
            v-model="finishDiaForm.rechargeTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="timestamp"
            format="yyyy-MM-dd HH:mm:ss"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div class="flex" style="align-items: flex-start;margin: 10px 0;">
          <span style="flex-shrink: 0;">充值凭证:</span>
          <div>
            <JudgementsList
              v-if="finishClickDiaShow"
              :is-reset="isResponsibilityReset"
              :source-data="finishVoucherList"
              :fileSize="5"
              @dataChange="(v) => judgementsChange(v)"
            />
            <p class="el-upload__tip" style="padding-left: 15px;">
              请上传本次的收款凭证（限3张内，大小不超过5M，格式为JPG或PNG）
            </p>
          </div>
        </div>
        <div class="flex">
          <span style="flex-shrink: 0;margin-right: 15px;">动态口令:</span>
          <el-input
            size="small"
            v-model="finishDiaForm.command"
            placeholder="请输入谷歌动态口令"
            @input="
              (val) =>
                (finishDiaForm.command = val.replace(/[^0-9a-zA-Z]/gi, ''))
            "
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="finishClickDiaShow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="finishBtnLoading"
          @click.native="finishClickSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="完成充值提示"
      :visible.sync="abolishDiaShow"
      :close-on-click-modal="false"
      width="500px"
      top="3%"
    >
      <div>
        <p style="color: #333333;">是否确认作废充值单据？</p>
        <p class="mt-10" style="color: #FF5353;">
          作废后，系统将不作为充值成功单据进行记录。如已线下充值成功，可能会导致与当换平台实际充值金额核对不一致。
        </p>
        <div class="flex mt-10">
          <span style="flex-shrink: 0;">作废原因： </span>
          <el-input
            type="textarea"
            :rows="2"
            maxlength="200"
            placeholder="请输入原因说明（限200字）"
            show-word-limit
            v-model="abolishDiaForm.abolishNote"
          >
          </el-input>
        </div>
        <div class="flex mt-10">
          <span style="flex-shrink: 0;">动态口令： </span>
          <el-input
            size="small"
            v-model="abolishDiaForm.command"
            placeholder="请输入谷歌动态口令"
            @input="
              (val) =>
                (abolishDiaForm.command = val.replace(/[^0-9a-zA-Z]/gi, ''))
            "
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="abolishDiaShow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="abolishBtnLoading"
          @click.native="abolishClickSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import GardenSlwct from "@/components/common/gardenSlwct.vue";
import { convertToRMB } from "@/utils/common";
import JudgementsList from "../componets/JudgementsList.vue";

export default {
  components: { GardenSlwct, JudgementsList },
  data() {
    return {
      balanceLoading: false,
      staffList: [],
      availableAmount: 0,
      frozenAmount: 0,
      queryTime: "",
      searchLoading: false,
      formData: {
        uniqNo: "",
        createAdminAccount: "",
      },
      createTime: [
        moment()
          .day(moment().day() - 30)
          .format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59"),
      ],
      rechargeTime: null,
      finishTime: null,
      cancelTime: null,
      tabActiveIndex: 0,
      state: "00",
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      tabData: [
        {
          text: "充值中",
          value: "00",
          num: 0,
        },
        {
          text: "充值完成",
          value: "01",
          num: 0,
        },
        {
          text: "充值作废",
          value: "10",
          num: 0,
        },
      ],
      searchParams: {},
      exportLoading: false,
      tableDataList: [],
      tableColumns: [
        { label: "单据号", prop: "uniqNo" },
        { slotName: "rechargeAmount" },
        { label: "大写", prop: "rechargeAmountChinese" },
        { slotName: "optName" },
        { label: "创建时间", prop: "createTime" },
        { slotName: "rechargeLink" },
        { slotName: "rechargeTime" },
        { slotName: "finishVoucherList" },
        { slotName: "finishAdminName" },
        { slotName: "finishTime" },
        { slotName: "abolishAdminName" },
        { slotName: "abolishTime" },
        { slotName: "abolishNote" },
        { slotName: "operation" },
      ],
      currentRow: {},
      // 凭证图片
      imgDiaShow: false,
      imgList: [],
      imgShowIndex: 0,
      // 创建充值弹框
      rechargeDiaShow: false,
      amount: "",
      onAmount: "",
      uniqNo: "",
      rechargeAmountChinese: "",
      getLinkLoading: false,
      rechargeLink: "",
      // 完成充值弹框
      finishClickDiaShow: false,
      isResponsibilityReset: false,
      finishBtnLoading: false,
      finishVoucherList: [],
      finishDiaForm: {
        rechargeTime: null,
        command: "",
      },
      // 作废弹框
      abolishDiaShow: false,
      abolishBtnLoading: false,
      abolishDiaForm: {
        abolishNote: "",
        command: "",
      },
    };
  },
  created() {
    this.operatorSelect();
    this.searchBalance();
    this.getTableData(1);
  },
  mounted() {},
  watch: {
    state(val) {
      this.rechargeTime = null;
      this.finishTime = null;
      this.cancelTime = null;
    },
  },
  methods: {
    createDatePickerOptions() {
      let pickerMinDate = null;
      const day31 = 31 * 24 * 60 * 60 * 1000;
      return {
        onPick: ({ minDate }) => {
          if (minDate) {
            pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (pickerMinDate) {
            return (
              time.getTime() >= pickerMinDate + day31 ||
              time.getTime() <= pickerMinDate - day31
            );
          }
          return false;
        },
      };
    },
    // 资⾦查询
    searchBalance() {
      this.balanceLoading = true;
      _api
        .queryWalletAmount()
        .then((res) => {
          console.log(res);
          this.availableAmount = res.data.availableAmount;
          this.frozenAmount = res.data.frozenAmount;
          this.queryTime = res.data.queryTime;
        })
        .finally(() => {
          this.balanceLoading = false;
        });
    },
    // 获取操作人下拉
    operatorSelect() {
      _api.StaffManageList({ pageSize: 99999 }).then((res) => {
        this.staffList = res.data.records;
      });
    },
    tabAction(val) {
      if (this.tabActiveIndex == val) {
        return;
      }
      this.tabActiveIndex = val;
      this.state = this.tabData[val].value;
      this.getTableData(1);
    },
    getTableData(pageNum) {
      this.tableDataList = []
      if (pageNum) {
        this.page.pageNum = pageNum;
      }
      let startCreateTime = "";
      let endCreateTime = "";
      let startRechargeTime = "";
      let endRechargeTime = "";
      let startFinishTime = "";
      let endFinishTime = "";
      let startAbolishTime = "";
      let endAbolishTime = "";
      if (this.createTime == null) {
        startCreateTime = "";
        endCreateTime = "";
      } else {
        startCreateTime = moment(this.createTime[0]).format("x");
        endCreateTime = moment(this.createTime[1]).format("x");
      }
      if (this.rechargeTime == null) {
        startRechargeTime = "";
        endRechargeTime = "";
      } else {
        startRechargeTime = moment(this.rechargeTime[0]).format("x");
        endRechargeTime = moment(this.rechargeTime[1]).format("x");
      }
      if (this.finishTime == null) {
        startFinishTime = "";
        endFinishTime = "";
      } else {
        startFinishTime = moment(this.finishTime[0]).format("x");
        endFinishTime = moment(this.finishTime[1]).format("x");
      }
      if (this.cancelTime == null) {
        startAbolishTime = "";
        endAbolishTime = "";
      } else {
        startAbolishTime = moment(this.cancelTime[0]).format("x");
        endAbolishTime = moment(this.cancelTime[1]).format("x");
      }
      let parame = {
        ...this.formData,
        state: this.state,
        startCreateTime,
        endCreateTime,
        startRechargeTime,
        endRechargeTime,
        startFinishTime,
        endFinishTime,
        startAbolishTime,
        endAbolishTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.searchParams = parame;
      this.searchLoading = true;
      _api
        .rechargeList(parame)
        .then((res) => {
          console.log(res);
          this.tableDataList = res.data.page.records;
          this.page.total = res.data.page.total;
          this.tabData[0].num = res.data.doingCount
          this.tabData[1].num = res.data.finishCount
          this.tabData[2].num = res.data.abolishCount
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    //创建充值
    openRechargeDia() {
      this.amount = "";
      this.onAmount = "";
      this.uniqNo = "";
      this.rechargeLink = "";
      this.rechargeAmountChinese = "";
      this.rechargeDiaShow = true;
    },
    amountInput() {
      this.amount = this.amount.toString().replace(/\D/g, "");
      if (this.amount > 0) {
        this.rechargeAmountChinese = convertToRMB(this.amount);
      } else {
        this.rechargeAmountChinese = "";
      }
    },
    // 获取充值链接
    getRechargeLink() {
      this.getLinkLoading = true;
      let parame = {
        amount: this.amount,
        uniqNo: this.uniqNo || "",
      };
      _api
        .createRechargeLink(parame)
        .then((res) => {
          this.onAmount = this.amount;
          this.uniqNo = res.data.uniqNo;
          this.rechargeLink = res.data.rechargeLink;
          this.getTableData(1);
        })
        .finally(() => {
          this.getLinkLoading = false;
        });
    },
    // 完成充值
    openFinishDia() {
      this.rechargeDiaShow = false
      this.finishDiaForm.rechargeTime = new Date().getTime();
      this.finishDiaForm.command = "";
      this.finishVoucherList = [];
      this.finishClickDiaShow = true;
    },
    // 查看凭证
    seeVoucher(imgs) {
      this.imgList = imgs;
      this.imgDiaShow = true;
    },
    seeLink(row) {
      this.amount = row.rechargeAmount;
      this.onAmount = row.rechargeAmount;
      this.uniqNo = row.uniqNo;
      this.rechargeLink = row.rechargeLink;
      if (this.amount > 0) {
        this.rechargeAmountChinese = convertToRMB(this.amount);
      } else {
        this.rechargeAmountChinese = "";
      }
      this.rechargeDiaShow = true;
    },
    getImgIndex(e) {
      this.imgShowIndex = e;
    },

    finishClick(row) {
      this.finishDiaForm.rechargeTime = new Date().getTime();
      this.finishDiaForm.command = "";
      this.finishVoucherList = [];
      this.uniqNo = row.uniqNo
      this.onAmount = row.rechargeAmount
      this.rechargeAmountChinese = row.rechargeAmountChinese

      this.finishClickDiaShow = true;
    },
    finishClickSure() {
      let finishVoucherList = [];
      if (this.finishVoucherList && this.finishVoucherList.length) {
        finishVoucherList = this.finishVoucherList
          .filter((item) => item.url)
          .map((item) => item.url);
      }
      if (!finishVoucherList.length) {
        return this.$message.error("请上传充值凭证");
      } else if (!this.finishDiaForm.command.trim()) {
        return this.$message.error("请输入动态口令");
      }
      let parame = {
        ...this.finishDiaForm,
        finishVoucherList,
        uniqNo: this.uniqNo,
      };
      this.finishBtnLoading = true;
      _api
        .completeRecharge(parame)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg || "操作成功!");
            this.finishClickDiaShow = false;
            this.getTableData(1);
          }
        })
        .finally(() => {
          this.finishBtnLoading = false;
        });
    },
    cancelClick(row) {
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.abolishDiaForm = {
        abolishNote: "",
        command: "",
      };
      this.abolishDiaShow = true;
    },
    abolishClickSure() {
      if (!this.abolishDiaForm.abolishNote.trim()) {
        return this.$message.error("请输入作废原因");
      } else if (!this.abolishDiaForm.command.trim()) {
        return this.$message.error("请输入动态口令");
      }
      let params = {
        id: this.currentRow.id,
        command: this.abolishDiaForm.command,
        abolishNote: this.abolishDiaForm.abolishNote,
      };
      this.abolishBtnLoading = true;
      _api
        .depositsRecharge(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg || "操作成功!");
            this.abolishDiaShow = false;
            this.getTableData(1);
          }
        })
        .finally(() => {
          this.abolishBtnLoading = false;
        });
    },
    copy() {
      const oInput = document.createElement("input");
      // oInput.value = `当换充值${this.onAmount}元：${this.rechargeLink}`;
      oInput.value = this.rechargeLink;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    // 凭证
    judgementsChange(v) {
      this.finishVoucherList = v;
    },
    clickExcel() {
      this.exportLoading = true;
      _api
        .rechargeExport(this.searchParams)
        .then((res) => {
          console.log(res);
          const content = res;
          this.codeShow = false;
          this.code = "";
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                this.$message.error(data.msg || "导出失败");
              }
            } catch (err) {
              const fileName = "充值列表.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
          this.exportLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.exportLoading = false;
        })
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.dhRechargeManage {
  .flex {
    display: flex;
    align-items: center;
  }
  .flex_jb {
    display: flex;
    justify-content: space-between;
  }
  .flex1 {
    flex: 1;
  }
  .mr-100 {
    margin-right: 100px;
  }
  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #0981ff;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .balance_box {
    background-image: url("../../../assets/images/balance_bg.png");
    width: 825px;
    height: 90px;
    background-size: 100% 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    .balance_icon {
      width: 60px;
      height: 60px;
      margin-right: 20px;
    }
    .balance_title {
      color: #333;
      font-size: 16px;
      font-weight: 500;
    }
    .balance_time {
      color: #999;
      font-size: 12px;
    }
    .search_btn {
      width: 44px;
      height: 22px;
      background: #ffffff;
      border-radius: 11px;
      font-size: 12px;
      color: #ff9324;
      text-align: center;
      line-height: 22px;
      margin-left: 10px;
      cursor: pointer;
    }
    .balance_num {
      color: #666;
      font-size: 14px;
      margin-top: 14px;
    }
  }
  // 弹窗
  .img-box {
    margin-bottom: 20px;

    // 图片
    .imgs-num {
      text-align: center;
      margin: 5px 0;
      font-weight: bold;
    }
    .sec_img {
      width: 20vw;
      height: 80vh;
      margin: auto;

      img {
        width: 20vw;
        height: 80vh;
        object-fit: contain;
      }
    }
  }
  .chinese_amount {
    padding-left: 70px;
    margin-top: 10px;
    color: #ff606f;
  }
  .link_box {
    box-sizing: border-box;
    width: 100%;
    background-color: #e4ecfd;
    border-radius: 10px;
    margin-top: 10px;
    padding: 10px;
  }
  .nowrap-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}
</style>
